import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VideoPlayerModalComponent } from '../video-player-modal/video-player-modal.component';

@Component({
  selector: 'app-video-card',
  templateUrl: './video-card.component.html',
  styleUrls: ['./video-card.component.scss']
})
export class VideoCardComponent implements OnInit, AfterViewInit {

  @Input() videoUrl!: string;
  @Input() modalTitle: string = 'Tutorial em vídeo';
  @Input() openInModal: boolean = true;
  @Input() autoPlay: boolean = false;
  @Input() showControlsOnStart: boolean = false;
  @ViewChild('videoPlayer') videoElementRef!: ElementRef<HTMLVideoElement>;
  isPlaying: boolean = false;
  showControls: boolean = false;
  showBackDrop: boolean = true;

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
    this.showControls = this.showControlsOnStart;
    this.showBackDrop = !this.showControlsOnStart;
    this.isPlaying = this.autoPlay;
  }

  ngAfterViewInit(): void {
    if (this.autoPlay) {
      setTimeout(() => this.playInlineVideo());
    }
  }

  // O card em volta também pode abrir o vídeo; parar aqui evita abrir duas vezes
  onCoverClick(event: Event): void {
    event.stopPropagation();
    this.playVideo();
  }

  playVideo(): void {
    if (this.openInModal) {
      this.openVideoModal();
      return;
    }

    this.playInlineVideo();
  }

  private playInlineVideo(): void {
    if (!this.videoElementRef) {
      return;
    }

    const videoPlayer = this.videoElementRef.nativeElement;
    const playPromise = videoPlayer.play();

    if (playPromise) {
      playPromise.catch(() => {
        this.isPlaying = false;
        this.showControls = true;
        this.showBackDrop = true;
      });
    }

    this.isPlaying = true;
    this.showControls = true;
    this.showBackDrop = false;
  }

  private openVideoModal(): void {
    this.dialog.open(VideoPlayerModalComponent, {
      width: '960px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      panelClass: ['video-player-dialog'],
      data: {
        title: this.modalTitle,
        videoUrl: this.videoUrl
      }
    });
  }

}
